import { render, staticRenderFns } from "./DiscountPackages.vue?vue&type=template&id=477356bc&scoped=true&"
import script from "./DiscountPackages.vue?vue&type=script&lang=js&"
export * from "./DiscountPackages.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPackages.vue?vue&type=style&index=0&id=477356bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477356bc",
  null
  
)

export default component.exports